// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";

import Endpoints from "../Endpoints";

// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

// ## SpecialDiscount Get
/**
 *
 * @param {{params: object, query: { page: number, limit: number }}} option
 *
 * @returns
 */
export const GetAll = async (option) => {
  const response = await $api.get(Endpoints.SpecialDiscount.GetAll(option));
  const checker = await ResponseChecker(defaultMessages, response);

  return checker;
};
// ## SpecialDiscount Create
/**
 *
 * @param {{ "differentProductCount": number, "discountRate": number }} form
 *
 * @returns
 */
export const Create = async (form) => {
  const response = await $api.post(Endpoints.SpecialDiscount.Create(), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## SpecialDiscount Get ById
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const GetById = async (option) => {
  const response = await $api.get(Endpoints.SpecialDiscount.GetById(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## SpecialDiscount Update
/**
 *
 * @param {{ "differentProductCount": number, "discountRate": number, isActive: boolean }} form
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Update = async (form, option) => {
  const response = await $api.put(
    Endpoints.SpecialDiscount.Update(option),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## SpecialDiscount Delete
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Delete = async (option) => {
  const response = await $api.delete(Endpoints.SpecialDiscount.Delete(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export default {
  GetAll,
  Create,
  GetById,
  Update,
  Delete,
};
